import { usePageProps } from './usePageProps';

export const useLanguage = () => {
  const {
    params: { lng }
  } = usePageProps();

  return lng;
};
